/**
*功能名称：必填
*创 建 人：弋强
*日    期：2022/08/31 14:52:07
*/
import { BaseVue, ItemInfo } from "@newview/base-web";
import { Component, Prop, Watch } from "vue-property-decorator";
import { grid, comForm, customModal, filterTool } from "@newview/ui";

@Component({
    components: {

    }
})
export default class NvTemplate extends BaseVue {

    //#region 变量定义区

    /**
     * 架构
     */
    @Prop({ default: () => ({}) })
    schemaNode: any;

    /**
     * 父对象
     */
    @Prop({ default: () => (undefined) })
    parentNmis: any;

    /**
     * 父数据
     */
    @Prop({ default: () => ({}) })
    parentData: any;

    /**
     * 父元素修改索引
     */
    @Prop({ default: 0 })
    parentChangeIndex?: number;

    /**
     * 组件Id映射
     */
    @Prop({ default: () => ({}) })
    componentIdMap?: any;

    /**
     * 是否为编辑模式
     */
    @Prop({ default: false })
    isEditor?: boolean;

    changeIndex: number = 1;
    currentData: any = {}; // 当前对象数据 父对象数据通过 __super 获取
    openData: any = {}; // 展开后的数据
    copySchemaNode: any; // 用于渲染的schema, 初始时复制schemaNode, 运算表达式后获取表达式的值
    dom: any;
    $vue: any;

    // 属性数据
    propertyId: string = this.getUniqueCode();
    propertyType: string = "";
    propertyValue: any = "";
    propertyChild: any[] = [];

    //#endregion 变量定义区

    //#region 事件定义区

    async mounted() {
        // 3. DOM创建完毕
        this.$vue = this.dom.componentInstance;

        this.getInitPropertyValue();
        this.doChange();
    }

    created() {
        this.currentData = Object.assign(this.currentData, this.isNull(this.schemaNode.data) ? {} : this.schemaNode.data);
        this.$set(this.currentData, '__super', this.parentData);
        this.copySchemaNode = this.fromJS(this.schemaNode);
        this.openData = filterTool.openData(this.currentData);

        if (Object.keys(this.componentIdMap).length == 0) {
            this.componentIdMap["root"] = this;
        }

        // 记录组件和id的关联
        if (!this.isNull(this.copySchemaNode.id)) {
            this.componentIdMap[this.copySchemaNode.id] = this;
        }
    }

    //#endregion 事件定义区

    //#region 方法定义区

    @Watch('schemaNode', { immediate: false, deep: true })
    onSchemaNodeChanged(val: any, oldVal: any) {
        this.currentData = Object.assign(this.currentData, this.isNull(this.schemaNode.data) ? {} : this.schemaNode.data);
        this.openData = filterTool.openData(this.currentData);
        this.copySchemaNode = this.fromJS(this.schemaNode);
    }

    @Watch('parentChangeIndex', { immediate: false, deep: false })
    onParentChangeIndexChanged(val: any, oldVal: any) {
        this.currentData.__super = this.parentData;
        this.openData = filterTool.openData(this.currentData);
        this.changeIndex += 1;
    }

    /**
     * 值改变事件
     * @param data 
     */
    doChange(data: any = undefined) {
        if (!this.isNull(data)) {
            let existValue = this.propertyChild.filter(item => item.id == data.id);
            if (existValue.length > 0) {
                existValue[0].value = data.value;
            } else {
                this.propertyChild.push(data);
            }
        }

        this.$emit("change", {
            id: this.propertyId,
            type: this.propertyType,
            value: this.propertyValue,
            child: this.propertyChild
        });
    }

    /**
     * 获取初始属性值
     */
    getInitPropertyValue() {
        switch (this.propertyType) {
            case "换行":
                this.propertyValue = this.getProp("lineNumber");
                break;
            case "空格":
                this.propertyValue = this.getProp("spaceNumber");
                break;
            case "列表项":
                this.propertyValue = false;
                break;
            case "列表":
                this.propertyValue = "";
                break;
            case "复选框":
                this.propertyValue = [];
                break;
            case "单选框":
                this.propertyValue = "";
                break;
            case "下拉框":
                this.propertyValue = "";
                break;
            case "输入框":
                this.propertyValue = "";
                break;
            case "文本":
                this.propertyValue = this.copySchemaNode["body"];
                break;
            case "段落":
                this.propertyValue = "";
                break;
            default:
                this.propertyValue = "";
                break;
        }
    }

    /**
     * 获取属性值
     * @param key 
     * @returns 
     */
    getProp(key) {
        if (this.isNull(this.copySchemaNode["props"])) {
            return "";
        }

        return this.copySchemaNode["props"][key];
    }

    /**
     * 添加Prop
     * @param key 
     * @param value 
     */
    addProp(key, value) {
        if (this.isNull(this.copySchemaNode["props"])) {
            this.copySchemaNode["props"] = {};
        }
        this.copySchemaNode["props"][key] = value;
    }

    /**
     * 添加事件监听
     */
    addEvent(key, value) {
        if (this.isNull(this.copySchemaNode["on"])) {
            this.copySchemaNode["on"] = {};
        }
        this.copySchemaNode["on"][key] = value;
    }

    /**
     * 创建Dom
     * @param h 
     * @param body 
     * @param slot 
     * @returns 
     */
    createDom(h, body, slots: any[]) {
        const type = this.copySchemaNode["type"];

        this.propertyType = this.copySchemaNode["title"];

        // 获取当前组件的值
        this.addEvent("input", (value) => {
            switch (this.propertyType) {
                case "段落":
                case "模板内容":
                    this.propertyValue = "";
                    break;
                default:
                    this.propertyValue = value;
                    break;
            }
            this.doChange();
        });

        body = filterTool.autoFilterValue(body, this.openData);

        if (!Array.prototype.isPrototypeOf(body)) {
            body = [body];
        }
        body = slots.concat(body);

        // 4. 创建DOM
        const newSchema = this.fromJS(this.copySchemaNode);
        const data = filterTool.autoFilterValue(body, this.openData);
        this.dom = h(type, newSchema, data);

        return this.dom;
    }

    /**
     * 创建孩子节点
     * @param h 
     * @param json 
     * @param slotName 
     * @returns 
     */
    createChild(h, json, slotName: string | 'default' = 'default') {
        if (this.isNull(h) || this.isNull(json) || this.isNull(json.type)) {
            return undefined;
        }

        if (!filterTool.doFilterBoolean(json['if'], this.openData)) {
            return undefined;
        }

        const isShow = filterTool.doFilterBoolean(json["show"], this.openData);
        const childDom = h('nvTemplate', {
            props: {
                schemaNode: json,
                parentData: this.currentData,
                parentChangeIndex: this.changeIndex,
                componentIdMap: this.componentIdMap,
                parentNmis: this,
                isEditor: this.isEditor,
                linkParam: this.linkParam
            },
            slot: slotName,
            style: {
                display: isShow ? "" : "none"
            },
            on: {
                change: (data) => {
                    // 提交孩子值
                    this.doChange(data);
                }
            }
        });

        return childDom;
    }

    render(h) {
        const body = this.schemaNode["body"];
        const slot = this.schemaNode.slot;

        // 0. slot
        const slotDoms: any[] = [];
        if (!this.isNull(slot)) {
            for (const key in slot) {
                const slotDom = this.createChild(h, slot[key], key);

                if (!this.isNull(slotDom)) {
                    slotDoms.push(slotDom);
                }
            }
        }

        // 1. 渲染节点
        if (this.isNull(body) || typeof (body) == "string") {
            return this.createDom(h, this.isNull(body) ? '' : body, slotDoms);
        }

        // 2. 组织孩子节点Schema
        const bodyDom: any[] = [];
        let bodyJsonArray: any[] = [];
        if (Array.prototype.isPrototypeOf(body)) {
            bodyJsonArray = body;
        } else {
            bodyJsonArray.push(body);
        }

        // 3. 渲染孩子节点
        for (const bodyJson of bodyJsonArray) {

            const childDom = this.createChild(h, bodyJson);

            if (!this.isNull(childDom)) {
                bodyDom.push(childDom);
            }
        }

        // 4. 渲染节点
        return this.createDom(h, bodyDom, slotDoms);
    }

    //#endregion 方法定义区


    // ================================================================================================================================
    // ================================================================================================================================
    // ================================================================================================================================

    //#region 公开Api定义区
    /**
     * 获取根组件
     * @returns 
     */
    getRootComponent() {
        return this.componentIdMap.root;
    }

    /**
     * 根据组件Id获取组件
     * @param componentId 
     * @returns 
     */
    getComponentById(componentId) {
        if (filterTool.isNull(componentId)) {
            return undefined;
        }

        if (filterTool.isNull(this.componentIdMap[componentId])) {
            return undefined;
        }

        const nmis: any = this.componentIdMap![componentId];
        return nmis;
    }

    /**
     * 获取数据
     * @param componentId 
     * @returns 
     */
    getDataById(componentId) {
        const nmis: any = this.getComponentById(componentId);
        if (nmis == undefined) {
            return undefined;
        }
        return nmis.currentData;
    }

    /**
     * 设置数据
     * @param componentId 
     * @returns 
     */
    setDataById(componentId, data) {
        const nmis: any = this.getComponentById(componentId);
        if (nmis == undefined) {
            return;
        }

        for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                const element = data[key];
                this.$set(nmis.currentData, key, element);
            }
        }
        nmis.openData = filterTool.openData(nmis.currentData);
        nmis.update();
    }

    /**
     * 设置值
     * @param data 
     */
    setData(data) {
        for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                const element = data[key];
                this.$set(this.currentData, key, element);
            }
        }
        this.openData = filterTool.openData(this.currentData);
        this.update();
    }

    /**
     * 获取值
     * @returns 
     */
    getData() {
        return filterTool.jsonClone(this.currentData);
    }

    /**
     * 更新当前元素
     */
    update() {
        this.changeIndex += 1;
    }

    //#endregion 公开Api定义区
}